import React, { useEffect, useState } from 'react';
import {Button,Input} from 'reactstrap';
import { useParams, Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Prompt from '../components/Prompt';
import { Comparison } from '../components/Tables';
import { request } from '../api';
export default function Settlement() {
  const {
      id
    } = useParams(),
    [data, setData] = useState(null),
    [prompt, setPrompt] = useState(''),
    [raw, setRaw] = useState(''),
    [preview, setPreview] = useState(null),
    [error, setError] = useState(''),
    [busy, setBusy] = useState(false);
  useEffect(() => {
    let live = true;
    request(`/batches/${id}`).then(d => live && setData(d)).catch(e => live && setError(e.message));
    return () => {
      live = false;
    };
  }, [id]);
  const run = async fn => {
    setBusy(true);
    setError('');
    try {
      await fn();
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };
  return <Layout title="Batch settlement" error={error}>{data && <>
    <p>{data.batch.horizon} · Closing dates: {data.batch.start_date} → {data.batch.end_date} · Target close: {data.batch.target_close}</p>
    <Comparison predictions={data.predictions} />
    {data.batch.status === 'settled' ? <p>Settlement complete.{data.batch.is_system && ` Blogger: ${data.publication?.status}.`} {data.predictions[0] && <Link to={`/extreme-movers/predictions/${data.predictions[0].id}`}>View results</Link>}</p> : data.can_manage && <>
      <Button color="primary" className="my-2" disabled={busy} onClick={() => run(async () => {
          const d = await request(`/batches/${id}/settlement/prompt`, {});
          setPrompt(d.prompt);
        })}>Generate shared price prompt</Button>
      {prompt && <><Prompt text={prompt} /><label>Paste researched prices<Input type="textarea" disabled={busy} rows={12} value={raw} onChange={e => {
              setRaw(e.target.value);
              setPreview(null);
            }} /></label><Button color="primary" className="my-2" disabled={busy || !raw} onClick={() => run(async () => setPreview(await request(`/batches/${id}/settlement/preview`, {
            response: raw
          })))}>Parse and preview</Button></>}
      {preview && <section className="em-panel"><h2>Verify all shared prices</h2><p>To correct a price, edit the JSON above and preview again. Split-adjusted closes; no dividend adjustments.</p><div className="em-table"><table className="table align-middle"><thead className="table-light"><tr><th>Symbol</th><th>Start</th><th>End</th><th>Source</th><th>Notes</th></tr></thead><tbody>{preview.prices.map(p => <tr key={p.symbol}><td>{p.symbol}</td><td>{p.start_close}</td><td>{p.end_close}</td><td>{p.source}</td><td>{p.notes}</td></tr>)}</tbody></table></div>
        <Comparison predictions={data.predictions.map(p => ({
            ...p,
            result: preview.results.find(r => r.prediction_id === p.id)
          }))} />
        <p>{data.batch.is_system?'Confirmation makes all model results public and queues a Blogger article.':'Confirmation scores every model in this run and shares the results with other subscribers. Your own research is never published to the blog.'} Settlement cannot be overwritten.</p><Button color="primary" className="my-2" disabled={busy} onClick={() => run(async () => {
            await request(`/batches/${id}/settlement`, {
              response: raw
            });
            setData(await request(`/batches/${id}`));
            setPreview(null);
          })}>Confirm settlement and publish</Button>
      </section>}
    </>}
  </>}</Layout>;
}
